export const FETCH_RELEASE_NOTES_STARTED = 'FETCH_RELEASE_NOTES_STARTED';
export const FETCH_RELEASE_NOTES_SUCCESS = 'FETCH_RELEASE_NOTES_SUCCESS';
export const FETCH_RELEASE_NOTES_FAILIED = 'FETCH_RELEASE_NOTES_FAILIED';
